<template>
	<div class="navList" :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">
		<div class="navHead">
			<div v-for="(item, index) in navList" :key="index" style="position: relative;">
				<!-- :style="item.routerName == 'AboutMe'?'line-height:31px;':''" -->
				<h2
					class="navTitle c-hover"
					:class="
						(navRouterName == item.routerName ? 'active' : '',
						dayNightMode == 'day' ? 'day-mode' : 'night-mode')
					"
					@click="goList(item.routerName, 0, item.bz)"
				>
					<span>{{ item.name }}</span>
				</h2>
				<ul class="nav-ul" :style="{ height: sonListHeight + 'px' }" v-if="item.son">
					<li
						v-for="(sonItem, sonIndexs) in item.son"
						:key="sonIndexs"
						class="c-hover"
						:class="
							(sonIndex == sonItem.id ? 'liActive' : '',
							dayNightMode == 'day' ? 'day-mode' : 'night-mode')
						"
						:to="'?type=' + sonItem.id"
						@click="goList(sonItem.id, 1, sonItem.bz)"
						>{{ en_cn == 'en' ? sonItem.title_en : sonItem.title }}</li
					>
				</ul>
				<!-- 用来占位获取sonList高度的 -->
				<ul class="nav-ul-seizeASeat" ref="sonList" v-if="isExpandNavigation">
					<li
						v-for="(sonItem, sonIndexs) in item.son"
						:key="sonIndexs"
						class="c-hover"
						:class="
							(sonIndex == sonItem.id ? 'liActive' : '',
							dayNightMode == 'day' ? 'day-mode' : 'night-mode')
						"
						:to="'?type=' + sonItem.id"
						>{{ en_cn == 'en' ? sonItem.title_en : sonItem.title }}</li
					>
				</ul>
			</div>
			<h4 :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'" class="languageSwitching">
				<span class="c-span" :class="en_cn == 'cn' ? 'active' : ''" @click="switchEnCn('cn')"
					>CN</span
				>
				/
				<span class="c-span d" :class="en_cn == 'en' ? 'active' : ''" @click="switchEnCn('en')"
					>EN
				</span>
			</h4>
			<!-- 日夜模式按钮 -->
			<div class="dayNightMode-box" :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">
				<h4 @click="switchDayNightMode('day')" :class="dayNightMode == 'day' ? 'active' : ''"
					>DAILY</h4
				>
				<span>/</span>
				<h4 @click="switchDayNightMode('night')" :class="dayNightMode == 'night' ? 'active' : ''"
					>NIGHT</h4
				>
			</div>
		</div>
		<div class="navFoot">
			<a
				:href="dataWeibo.weibo"
				rel="nofollow"
				:class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'"
				>WEIBO</a
			>
			<div class="navFoot-div" @click="showWechat">
				<a :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">WECHAT</a>
				<div class="navFoot-img" v-if="wechatBool">
					<img :src="dataWeibo.wechat" alt />
				</div>
			</div>
			<a
				:href="dataWeibo.ins"
				rel="nofollow"
				:class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'"
				>INSTAGRAM</a
			>
			<a
				:href="dataWeibo.behance"
				rel="nofollow"
				:class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'"
				>BEHANCE</a
			>
			<a
				class="beian"
				href="http://www.beian.miit.gov.cn/"
				rel="nofollow"
				:class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'"
				>{{ dataWeibo.icp }}</a
			>
			<a href="http://www.sorabrand.com"><img src="../assets/SORT.png" width="100%" alt="SORA"/></a>
		</div>
	</div>
</template>

<script>
	import { watch } from 'less';

	export default {
		data() {
			return {
				isEnglish: true, //判断是否是中文
				isRouter: '', //判断路由
				en_cn: '', // 判断是否是中文还是英文
				projectBool: false, //显示隐藏项目类的子导航

				navRouterName: '', //判断路由名称
				sonIndex: -1, //判断子导航
				navList: [
					{
						name: 'PROJECTS',
						routerName: 'pictureList',
						son: [
							// { name:"a.RESTAURANT", id:1 },
							// { name:"b.COMMUNITY", id:2 },
							// { name:"c.LIFESTYLE", id:3 },
							// { name:"d.OFFICE", id:4 },
							// { name:"e.HOTEL", id:5 },
							// { name:"f.MEDIA", id:6 },
						],
					},
					{
						name: 'CONTACT',
						routerName: 'Countent',
					},
					{
						name: 'ABOUT',
						routerName: 'AboutMe',
					},
				], //导航
				isExpandNavigation: false,
				sonListHeight: 0,

				dataWeibo: '', //链接数据
				wechatBool: false, //显示隐藏微信扫码图

				dayNightMode: 'day',
			};
		},
		created() {
			this.getTypeData();
			this.getListData();
			this.weboData();
			this.$store.state.fat_bool = 2;
			this.$store.state.homePage = 1;

			this.initPath();

			// 获取当前缓存是中文还是英文
			this.en_cn = sessionStorage.getItem('lang') || 'cn';
			this.$store.state.en_cn = sessionStorage.getItem('lang') || 'cn';

			this.checkTimeAndSwitchMode();
			// 每隔1分钟获取一下当前时间,判断是白天还是黑夜,06:00-18:00为白天,18:00-06:00为黑夜
			setInterval(() => {
				if (!this.$store.state.isChangeMode) {
					this.checkTimeAndSwitchMode();
				}
			}, 1000 * 60 * 1);
		},
		watch: {
			'$store.state.dayNightMode': function() {
				this.dayNightMode = this.$store.state.dayNightMode;
			},
		},
		methods: {
			// 处理路由
			initPath() {
				let fullPath = window.location.href.replace(window.location.origin, '').slice(1);
				// console.log('第一次进入网站的参数', fullPath);
				let bz = fullPath.split('-')[1];
				// console.log('bz', bz);
				if (bz) {
					let path = fullPath.split('-')[0];
					// console.log('path', path);
					if (path) {
						this.$store.state.projectsContBz = bz;
					} else {
						this.$store.state.homeBz = bz;
					}
				}
			},
			// 获取当前是白天还是黑夜
			checkTimeAndSwitchMode() {
				const date = new Date();
				const hour = date.getHours();
				if (hour >= 6 && hour < 18) {
					this.$store.commit('changeDayNightMode', 'day');
				} else {
					this.$store.commit('changeDayNightMode', 'night');
				}
			},
			// 切换日夜模式
			switchDayNightMode(mode) {
				this.$store.commit('changeMode', true);
				this.$store.commit('changeDayNightMode', mode);
				setTimeout(() => {
					this.$store.commit('changeMode', false);
				}, 1000 * 60 * 30);
			},

			// 切换中文和英文
			switchEnCn(type) {
				sessionStorage.setItem('lang', type);
				this.en_cn = type;
				this.$store.state.en_cn = sessionStorage.getItem('lang') || 'cn';
			},

			// 点击微信显示图片
			showWechat() {
				this.wechatBool = !this.wechatBool;
			},

			// 微博请求
			weboData() {
				this.$post('api/index/JumpInfo').then((res) => {
					this.dataWeibo = res.data;
				});
			},

			// 获取type数据
			async getTypeData() {
				try {
					let res = await this.$post('api/home/projectstype');
					this.navList[0].son = [...res.data];
				} catch (error) {
					console.log(error);
				}
			},
			// 获取list数据
			async getListData() {
				try {
					let res = await this.$get('api/home/ProjectsListall');
					this.$store.state.pictureData = [...res.data];
				} catch (error) {
					console.log(error);
				}
			},

			goList(path, type, bz) {
				this.sonIndex = -1;
				console.log(type == 0 ? '点击了父级导航栏' : '点击了子级导航栏');
				this.$store.state.fat_bool = 2;
				if (type == 0) {
					if (path == 'pictureList') {
						this.isExpandNavigation = !this.isExpandNavigation;
						this.getListData();
						this.$store.state.homeBz = '';
						this.$nextTick(() => {
							let sonList = this.$refs.sonList;
							let sonListHeight = sonList[0] ? sonList[0].offsetHeight : 0;
							// console.log(sonListHeight);
							this.sonListHeight = sonListHeight;
						});
					}
					this.$router.push({ name: path });
					this.navRouterName = path;
				} else {
					this.sonIndex = path;
					this.$router.push({
						name: 'pictureList',
					});
					setTimeout(() => {
						this.$store.state.homeBz = bz;
					}, 100);
				}
			},
		},
	};
</script>
<style lang="less" scoped>
	* {
		box-sizing: border-box;
	}
	@font-face {
		font-family: nexabold;
		src: url(../../public/font/NexaBold.otf);
	}
	@font-face {
		font-family: nexalight;
		src: url(../../public/font/NexaLight.otf);
	}
	@font-face {
		font-family: Source;
		src: url(../../public/font/SourceHanSansCN-Normal.otf);
	}

	.c-hover {
		margin-bottom: 2.5px;
		line-height: 0.1771rem;
		font-family: nexalight;
	}

	// .c-hover:last-child {
	//   margin-bottom: 4px;
	// }
	.c-hover:hover {
		font-family: nexabold;
	}
	.Source {
		font-family: Source;
	}

	.nav-ul {
		transition: 0.5s all;
		overflow: hidden;
		li {
			cursor: pointer;
		}
		li:last-child {
			padding-bottom: 12px;
		}
	}
	.nav-ul-seizeASeat {
		position: absolute;
		z-index: -10;
		opacity: 0;
	}
	.navList {
		padding: 0.1823rem 0.2083rem 0.2083rem 0.2083rem;
		background: #dbdcdc;
		word-wrap: break-word; //英文超出强制换行
		white-space: pre-wrap; //中文超出强制换行
	}
	.languageSwitching {
		margin-top: 0.1042rem;
		font-size: 0.1042rem !important;
		line-height: 1 !important;
	}
	.active {
		font-family: nexabold;
		// color: red;
	}
	.liActive {
		font-family: nexabold;
	}
	ul {
		li {
			font-family: nexalight;
			font-size: 0.1302rem;
			line-height: 0.1875rem;
		}
	}
	.navHead {
		font-family: nexalight;
		color: #231815;
		h2 {
			// font-size: 32px;
			font-size: 0.1667rem;
			line-height: 0.2083rem;
			cursor: pointer;
		}
		h4 {
			font-size: 0.1302rem;
			line-height: 0.1771rem;
		}
		.dayNightMode-box {
			display: flex;
			align-items: center;
			cursor: pointer;
			font-size: 0.1042rem;
			h4 {
				font-size: 0.1042rem;
			}
			span {
				margin: 0 0.0521rem;
			}
		}
	}
	.navFoot {
		//   position: absolute;
		//   bottom: 40px;
		font-family: nexabold;
		font-size: 0.1302rem;
		color: #231815;
		position: fixed;
		bottom: 0.2292rem;
		a {
			display: block;
			font-family: nexabold;
			font-size: 0.1302rem;
			letter-spacing: 1px;
			line-height: 0.151rem;
		}
		.beian {
			font-size: 0.0833rem;
		}
		img {
			margin: 0.0859rem 0 0.0469rem 0;
			width: 0.9323rem;
		}
	}

	.navFoot-div {
		position: relative;
		cursor: pointer;
	}

	.navFoot-img {
		width: 1.0417rem;
		position: absolute;
		bottom: 100%;
		left: 0;
	}

	// 新增
	.c-span {
		cursor: pointer;
	}
</style>
